import { CreateContactAttemptDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { workOrderApi } from "../service";
import { applyContactResult } from "./contactMutationSuccess";

/** Records one try to reach the tenant on a „Nicht erreicht" Auftrag. */
export function useAddContactAttempt() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ workOrderId, dto }: { workOrderId: string; dto: CreateContactAttemptDto }) => {
      const { data } = await workOrderApi.addContactAttempt(workOrderId, dto);
      return data;
    },
    onSuccess: (data, { workOrderId }) => applyContactResult(queryClient, workOrderId, data),
  });
}
